// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LogoutIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LogoutIcon" ref={forwardedRef} {...props}>
      <path d="M5.5 16.5v-13H12V2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7v-1.5z" />
      <path d="m16.5 10.001-4.242 4.243-1.061-1.061 2.433-2.433H8v-1.5h5.628l-2.431-2.431 1.06-1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LogoutIcon = /* @__PURE__ */ Object.assign(LogoutIconComponent, {
  displayName: 'LogoutIcon',
});
